export const AVAILABILITY_REQUEST_LIMIT_REACHED = "Reached request limit";
